import type { env as MoengageEnv } from '@moengage/web-sdk';
import Moe from '@moengage/web-sdk';

interface InitMoengageArgs {
  debug?: boolean;
  env?: MoengageEnv;
  workspaceId?: string | null;
}

/** @see https://www.moengage.com/docs/release-notes/sdks/web */
export const initMoengage = ({ debug, env, workspaceId }: InitMoengageArgs) => {
  if (!workspaceId) return;

  // eslint-disable-next-line import-x/no-named-as-default-member
  Moe.initialize({
    app_id: workspaceId,
    debug_logs: debug ? 1 : 0,
    env,
    cluster: 'DC_4',
  });
};
